export const COMPONENT_NAME = "registration-form";
